module.exports = function(ctx) {
  return ctx.store.dispatch('nuxtServerInit', ctx)
}
